<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="evaluaciones"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
        no-data-text="No hay datos"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="mr-1">Encuestas</v-toolbar-title>
            <v-divider inset vertical></v-divider>
            <v-col cols="auto" md="2">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Busqueda"
                single-line
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="px-1">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="indigo" dark v-bind="attrs" v-on="on">
                    Opciones
                  </v-btn>
                </template>
                <v-card>
                  <v-list>
                    <v-list-item>
                      <v-select
                        v-model="itemInfome"
                        :items="itemsTipoEncuesta"
                        dense
                        solo
                        hide-details
                      ></v-select>
                    </v-list-item>
                    <v-list-item>
                      <v-text-field
                        type="date"
                        v-model="fechaFin"
                        label="Desde la fecha"
                        :max="new Date().toISOString().substr(0, 10)"
                        hide-details
                      ></v-text-field>
                    </v-list-item>
                    <v-list-item>
                      <v-text-field
                        type="date"
                        label="Hasta la fecha"
                        v-model="fechaInicio"
                        :max="new Date().toISOString().substr(0, 10)"
                        hide-details
                      ></v-text-field>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </v-col>
            <v-card tile flat>
              <v-btn @click="listar()" color="primary" v-if="verDet == 0" dark
                >Filtrar</v-btn
              >
            </v-card>
            <v-card class="ml-1" tile flat>
              <v-btn
                @click="listarFiltros()"
                color="green"
                dark
                v-if="verDet == 0"
              >Descargar</v-btn>
            </v-card>
            <v-spacer></v-spacer>
            <v-card tile flat class="ml-1">
              <v-btn color="primary" dark @click="dialog = !dialog"
                >Nuevo</v-btn
              >
            </v-card>
          </v-toolbar>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="verDetalles(item)"
                v-bind="attrs"
                v-on="on"
              >
                tab
              </v-icon>
            </template>
            <span>Ver detalles</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2 far fa-trash-alt"
                @click="abrirDialogEliminarEval(item)"
                v-bind="attrs"
                v-on="on"
              >
              </v-icon>
            </template>
            <span>Eliminar evaluación</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.condicion`]="{ item }">
          <v-chip :color="getColorCondicion(item.condicion)" dark>
            <div v-if="item.condicion == false"><span>Creado</span></div>
            <div v-if="item.condicion == true"><span>Realizada</span></div>
            <div v-if="item.condicion == 'Creado'"><span>Creado</span></div>
            <div v-if="item.condicion == 'Enviada'"><span>Enviada</span></div>
            <div v-if="item.condicion == 'Realizada'">
              <span>Realizada</span>
            </div>
          </v-chip>
        </template>
      </v-data-table>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>

      <!-- Formulario evaluacion-->
      <v-container
        grid-list-sm
        class="pa-4 white"
        v-if="verNuevo && this.tipo_Encuesta == 'ENCUESTA EVALUACION SERVICIO'"
      >
        <v-layout align-start>
          <v-flex>
            <v-form
              v-model="valid"
              class="pa-5"
              style="background-color: white"
            >
              <p class="font-weight-bold text-center">
                ENCUESTA DE EVALUACION DE SERVICIO
              </p>
              <v-container class="white lighten-5 mb-6">
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" outlined tile>
                      Fecha de asistencia:
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="fecha"
                        label="Fecha de asistencia"
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="white lighten-5 mb-6">
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" outlined tile>
                      Compañía de seguros:
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="compañia"
                        label="Compañía de seguros"
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="white lighten-5 mb-6">
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" outlined tile>
                      Placa de vehículo asegurado:
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="placa"
                        label="Placa de vehículo asegurado"
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="white lighten-5 mb-6">
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" outlined tile>
                      País:
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="pais"
                        label="País"
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-container class="white lighten-5 mb-6">
                <p class="font-weight-bold">
                  Seleccione la alternativa que considere satisfactoria.
                </p>
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2 font-weight-bold" outlined tile>
                      ¿Como evalúa la atención telefónica cuando reporto su
                      emergencia?
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-radio-group row v-model="atencion_Telefonico">
                        <v-radio
                          label="Excelente"
                          value="Excelente"
                          color="success"
                        ></v-radio>
                        <v-radio
                          label="Bueno"
                          value="Bueno"
                          color="info"
                        ></v-radio>
                        <v-radio
                          label="Malo"
                          value="Malo"
                          color="error"
                        ></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2 font-weight-bold" outlined tile>
                      ¿Como evalúa la atención del asesor de asistencia?
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-radio-group row v-model="atencion_Asesor">
                        <v-radio
                          label="Excelente"
                          value="Excelente"
                          color="success"
                        ></v-radio>
                        <v-radio
                          label="Bueno"
                          value="Bueno"
                          color="info"
                        ></v-radio>
                        <v-radio
                          label="Malo"
                          value="Malo"
                          color="error"
                        ></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2 font-weight-bold" outlined tile>
                      ¿Como califica la presentación del asesor que llego al
                      lugar de la asistencia?
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-radio-group row v-model="presentacion_Asesor">
                        <v-radio
                          label="Excelente"
                          value="Excelente"
                          color="success"
                        ></v-radio>
                        <v-radio
                          label="Bueno"
                          value="Bueno"
                          color="info"
                        ></v-radio>
                        <v-radio
                          label="Malo"
                          value="Malo"
                          color="error"
                        ></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2 font-weight-bold" outlined tile>
                      ¿El asesor le explico el procedimiento a seguir para la
                      resolución de su reclamo?
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-radio-group row v-model="explico_procedimiento">
                        <v-radio
                          label="Excelente"
                          value="Excelente"
                          color="success"
                        ></v-radio>
                        <v-radio
                          label="Bueno"
                          value="Bueno"
                          color="info"
                        ></v-radio>
                        <v-radio
                          label="Malo"
                          value="Malo"
                          color="error"
                        ></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="white lighten-5 mb-6">
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2 font-weight-bold" outlined tile>
                      ¿Fue influenciado en alguna decisión por parte del asesor?
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-radio-group row v-model="influenciado_Por_Asesor">
                        <v-radio label="Si" value="Si" color="error"></v-radio>
                        <v-radio label="No" value="No" color="info"></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="white lighten-5 mb-6">
                <v-col>
                  <v-card class="pa-2 font-weight-bold" outlined tile>
                    ¿Por qué? Explique:
                  </v-card>
                </v-col>
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-textarea
                        v-model="influenciado_Por_Asesor_Porque"
                        hide-details
                        outlined
                        name="input-7-4"
                        label="¿Por qué? Explique:"
                      ></v-textarea>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="white lighten-5 mb-6">
                <v-col>
                  <v-card class="pa-2 font-weight-bold" outlined tile>
                    Comentario adicional o sugerencia favor detallarla en el
                    cuadro siguiente:
                  </v-card>
                </v-col>
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-textarea
                        v-model="comentario_Adicional"
                        hide-details
                        outlined
                        name="input-7-4"
                        label="Comentario"
                      ></v-textarea>
                    </v-card>
                  </v-col>
                </v-row>
                <v-btn @click="ocultarNuevo()" color="grey" dark>Cerrar</v-btn>
                <v-btn @click="listarDetalles()" color="blue" dark class="ml-2"
                  >Crear Link para encuesta</v-btn
                >
              </v-container>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- Formulario cierre-->
      <v-container
        grid-list-sm
        class="pa-4 white"
        v-if="verNuevo && this.tipo_Encuesta == 'ENCUESTA CIERRE SERVICIO'"
      >
        <v-layout align-start>
          <v-flex>
            <v-form
              v-model="valid"
              class="pa-5"
              style="background-color: white"
            >
              <p class="font-weight-bold text-center">
                ENCUESTA DE CIERRE DE SERVICIO
              </p>
              <v-container class="white lighten-5 mb-6">
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" outlined tile>
                      Fecha de asistencia:
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="fecha"
                        label="Fecha de asistencia"
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="white lighten-5 mb-6">
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" outlined tile>
                      Compañía de seguros:
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="compañia"
                        label="Compañía de seguros"
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="white lighten-5 mb-6">
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" outlined tile>
                      Placa de vehículo asegurado:
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="placa"
                        label="Placa de vehículo asegurado"
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container class="white lighten-5 mb-6">
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2" outlined tile>
                      País:
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="pais"
                        label="País"
                        disabled
                        hide-details
                      ></v-text-field>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-container class="white lighten-5 mb-6">
                <p class="font-weight-bold">
                  Seleccione la alternativa que considere satisfactoria.
                </p>
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2 font-weight-bold" outlined tile>
                      ¿Cómo califica el proceso de pago internacional?
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-radio-group row v-model="proceso_Pago">
                        <v-radio
                          label="Excelente"
                          value="Excelente"
                          color="success"
                        ></v-radio>
                        <v-radio
                          label="Bueno"
                          value="Bueno"
                          color="info"
                        ></v-radio>
                        <v-radio
                          label="Malo"
                          value="Malo"
                          color="error"
                        ></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2 font-weight-bold" outlined tile>
                      ¿Cómo considera usted el tiempo de espera para recibir su
                      indemnización?
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-radio-group row v-model="tiempo_Indemnizacion">
                        <v-radio
                          label="Excelente"
                          value="Excelente"
                          color="success"
                        ></v-radio>
                        <v-radio
                          label="Bueno"
                          value="Bueno"
                          color="info"
                        ></v-radio>
                        <v-radio
                          label="Malo"
                          value="Malo"
                          color="error"
                        ></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row align="center" no-gutters>
                  <v-col>
                    <v-card class="pa-2 font-weight-bold" outlined tile>
                      ¿Como evalúa usted a la aseguradora, según su experiencia?
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-radio-group row v-model="evaluacion_aseguradora">
                        <v-radio
                          label="Excelente"
                          value="Excelente"
                          color="success"
                        ></v-radio>
                        <v-radio
                          label="Bueno"
                          value="Bueno"
                          color="info"
                        ></v-radio>
                        <v-radio
                          label="Malo"
                          value="Malo"
                          color="error"
                        ></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-container class="white lighten-5 mb-6">
                <v-col>
                  <v-card class="pa-2 font-weight-bold" outlined tile>
                    ¿Recomendaría usted a nuestra compañía de seguros?
                  </v-card>
                </v-col>
                <v-row no-gutters>
                  <v-col cols="2" md="4">
                    <v-card class="pa-2 d-flex justify-center" flat tile>
                      <v-radio-group row v-model="recomendaria_Compañia">
                        <v-radio label="Si" value="Si" color="info"></v-radio>
                        <v-radio label="No" value="No" color="error"></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-textarea
                        v-model="recomendaria_Compañia_Porque"
                        hide-details
                        outlined
                        name="input-7-4"
                        label="Comentario"
                      ></v-textarea>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-container class="white lighten-5 mb-6">
                <v-col>
                  <v-card class="pa-2 font-weight-bold" outlined tile>
                    ¿Posee usted algún tipo de póliza para su vehículo con
                    alguna aseguradora?
                  </v-card>
                </v-col>
                <v-row no-gutters>
                  <v-col cols="2" md="4">
                    <v-card class="pa-2 d-flex justify-center" flat tile>
                      <v-radio-group row v-model="poliza_Vehiculo_Aseguradora">
                        <v-radio label="Si" value="Si" color="info"></v-radio>
                        <v-radio label="No" value="No" color="error"></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="poliza_Vehiculo_Aseguradora_Telefono"
                        hide-details
                        outlined
                        label="Telefono"
                      ></v-text-field>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-text-field
                        v-model="poliza_Vehiculo_Aseguradora_Correo"
                        hide-details
                        outlined
                        label="Correo electronico"
                      ></v-text-field>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-container class="white lighten-5 mb-6">
                <v-col>
                  <v-card class="pa-2 font-weight-bold" outlined tile>
                    ¿Fue influenciado en alguna decisión por parte del encargado
                    de gestionar su pago?
                  </v-card>
                </v-col>
                <v-row no-gutters>
                  <v-col cols="2" md="4">
                    <v-card class="pa-2 d-flex justify-center" flat tile>
                      <v-radio-group row v-model="influenciado_Por_pago">
                        <v-radio label="Si" value="Si" color="info"></v-radio>
                        <v-radio label="No" value="No" color="error"></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-textarea
                        v-model="influenciado_Por_pago_Porque"
                        hide-details
                        outlined
                        label="¿Por qué?"
                      ></v-textarea>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-container class="white lighten-5 mb-6">
                <v-col>
                  <v-card class="pa-2 font-weight-bold" outlined tile>
                    Comentario adicional o sugerencia favor detallarla en el
                    cuadro siguiente:
                  </v-card>
                </v-col>
                <v-row no-gutters>
                  <v-col>
                    <v-card class="pa-2" flat tile>
                      <v-textarea
                        v-model="comentario_Adicional"
                        hide-details
                        outlined
                        label="Comentario"
                      ></v-textarea>
                    </v-card>
                  </v-col>
                </v-row>
                <v-btn @click="ocultarNuevo()" color="grey" dark>Cerrar</v-btn>
                <v-btn @click="listarDetalles()" color="blue" class="ml-2" dark
                  >Crear Link para encuesta</v-btn
                >
              </v-container>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>

      <!--Dialog para crear evaluación -->
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn dark color="blue" @click="crearEncuesta()">
              Crear Encuesta
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="dialog = false">
                <i class="fas fa-times fa-2x"></i>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-row justify="center" align="center">
              <v-col cols="4" md="4">
                <v-text-field
                  class="pa-2"
                  v-model="numeroAsistencia"
                  label="NUMERO DE ASISTENCIA"
                  @keyup.enter="buscarNumeroAsistencia()"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" md="4">
                <v-text-field
                  class="pa-2"
                  v-model="fechaRequest"
                  label="Fecha"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="3" md="4">
                <v-text-field
                  class="pa-2"
                  v-model="compañiaRequest"
                  label="Compañia de seguros"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="3" md="4">
                <v-text-field
                  class="pa-2"
                  v-model="placaRequest"
                  label="Placa de vehículo asegurado"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="3" md="4">
                <v-text-field
                  class="pa-2"
                  v-model="paisRequest"
                  label="País"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="3" md="4">
                <v-select
                  :items="list_Crear_Tipo_Encuesta"
                  label="Tipo de encuesta"
                  v-model="crear_Tipo_Encuesta"
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
          </v-list>
          <!-- PreLoader -->
          <v-overlay v-model="overlay" z-index="0">
            <lottie-player
              autoplay
              loop
              mode="normal"
              src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
              style="width: 320px"
            >
            </lottie-player>
          </v-overlay>
        </v-card>
      </v-dialog>

      <!--Espacio para enviar encuesta evaluacion -->
      <v-bottom-sheet v-model="sheetEncuestaEvaluacion">
        <v-sheet class="text-center" height="auto">
          <p class="py-3 mb-0 title">
            El link a enviar para encuesta de evaluación es:
          </p>
          <v-container>
            <v-row justify="center" align="center">
              <v-col cols="12" md="1">
                <v-text-field
                  label="CODIGO"
                  hint="ejemplo: +503"
                  persistent-hint
                  v-model="codigoSMS"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  label="TELEFONO"
                  hint="Sin separadores"
                  persistent-hint
                  v-model="telefonoClienteEvaluacion"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea
                  solo
                  auto-grow
                  rows="1"
                  label="DATOS"
                  v-model="datosEncuestaEvaluacion"
                >
                </v-textarea>
              </v-col>
              <v-col cols="12" md="1">
                <v-btn
                  class="mt-6"
                  color="success"
                  target="_blanck"
                  :href="
                    this.urlWhatsapp +
                      this.codigoSMS +
                      this.telefonoClienteEvaluacion +
                      '&text=' +
                      encodeURIComponent(this.datosEncuestaEvaluacion)
                  "
                >
                  Enviar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-bottom-sheet>

      <!--Espacio para enviar encuesta cierre -->
      <v-bottom-sheet v-model="sheetEncuestaCierre">
        <v-sheet class="text-center" height="auto">
          <p class="py-3 mb-0 title">
            El link a enviar para encuesta de cierre es:
          </p>
          <v-container>
            <v-row justify="center" align="center">
              <v-col cols="12" md="1">
                <v-text-field
                  label="CODIGO"
                  hint="ejemplo: +503"
                  persistent-hint
                  v-model="codigoSMS"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  label="TELEFONO"
                  hint="Sin separadores"
                  persistent-hint
                  v-model="telefonoClienteCierre"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-textarea
                  solo
                  auto-grow
                  rows="1"
                  label="DATOS"
                  v-model="datosEncuestaCierre"
                >
                </v-textarea>
              </v-col>
              <v-col cols="12" md="1">
                <v-btn
                  class="mt-6"
                  color="success"
                  target="_blanck"
                  :href="
                    this.urlWhatsapp +
                      this.codigoSMS +
                      this.telefonoClienteCierre +
                      '&text=' +
                      encodeURIComponent(this.datosEncuestaCierre)
                  "
                  @click="crearEncuestaCierre()"
                >
                  Enviar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-bottom-sheet>

      <!-- Mensaje para borrar evaluacion -->
      <v-dialog v-model="borrarEval" max-width="290px">
        <v-card>
          <v-card-title class="headline">¿Borrar Evaluacion?</v-card-title>
          <v-card-text>
            Estas a punto de borrar evaluación
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="cancel" @click="borrarEval = !borrarEval">
              Cancelar
            </v-btn>
            <v-btn color="success" @click="eliminarEncuesta()">
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="mensajeBorrarSnack"
        :timeout="timeout"
        color="green"
        top
        right
      >
        Evaluación borrada
      </v-snackbar>

      <v-snackbar
        v-model="mensajeCrearSnack"
        :timeout="timeout"
        color="blue"
        top
      >
        Debe de seleccionar los campos primero.
      </v-snackbar>

      <v-snackbar
        v-model="mensajeSnack"
        :timeout="timeout"
        color="blue"
        top
        right
      >
        Debe de seleccionar los campos primero.
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
//import { db } from "../main";
import moment from "moment";

export default {
  data() {
    return {
      evaluaciones: [],
      arrayEvaluacion: [],
      arrayCierre: [],
      arrayTodo: [],
      search: "",
      menu: false,
      fechaInicio: "",
      fechaFin: "",
      itemInfome: "TODOS",
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Numero Asistencia",
          value: "numeroAsistencia",
          sortable: true,
        },
        { text: "Fecha creación", value: "fecha_Actual", sortable: true },
        { text: "Tipo Encuesta", value: "tipo_Encuesta", sortable: true },
        { text: "Fecha", value: "fecha", sortable: true },
        { text: "Compañia", value: "compañia", sortable: true },
        { text: "Placa", value: "placa", sortable: true },
        { text: "Pais", value: "pais", sortable: true },
        { text: "Estado", align: "left", value: "condicion", sortable: true },
      ],
      valid: "",
      dialog: false,
      itemsTipoEncuesta: [
        "TODOS",
        "ENCUESTA EVALUACION SERVICIO",
        "ENCUESTA CIERRE SERVICIO",
      ],
      //variables para los detalles del cliente
      numeroAsistenciaRequest: "",
      fechaRequest: "",
      compañiaRequest: "",
      placaRequest: "",
      paisRequest: "",
      errorPlacaRequest: null,
      //variables para los sheets
      sheetEncuestaEvaluacion: false,
      sheetEncuestaCierre: false,
      codigoSMS: "",
      telefonoClienteEvaluacion: "",
      telefonoClienteCierre: "",
      datosEncuestaEvaluacion: "",
      datosEncuestaCierre: "",
      urlWhatsapp: "https://api.whatsapp.com/send?phone=",
      //variables para las encuestas
      id: "",
      idEvaluaciones: "",
      idEvaluacionesEncrypt: "",
      numeroAsistencia: "",
      numeroAsistenciaEncrypt: "",
      condicion: false,
      fecha: "",
      compañia: "",
      placa: "",
      pais: "",
      atencion_Telefonico: "",
      atencion_Asesor: "",
      presentacion_Asesor: "",
      explico_procedimiento: "",
      influenciado_Por_Asesor: "",
      influenciado_Por_Asesor_Porque: "",
      comentario_Adicional: "",
      proceso_Pago: "",
      tiempo_Indemnizacion: "",
      evaluacion_aseguradora: "",
      recomendaria_Compañia: "",
      recomendaria_Compañia_Porque: "",
      poliza_Vehiculo_Aseguradora: "",
      poliza_Vehiculo_Aseguradora_Telefono: "",
      poliza_Vehiculo_Aseguradora_Correo: "",
      influenciado_Por_pago: "",
      influenciado_Por_pago_Porque: "",
      fecha_Actual: "",
      tipo_Encuesta: "",
      crear_Tipo_Encuesta: "",
      list_Crear_Tipo_Encuesta: [
        "ENCUESTA EVALUACION SERVICIO",
        "ENCUESTA CIERRE SERVICIO",
      ],
      mensajeSnack: false,
      timeout: 2500,
      //variables para encriptar y desencriptar
      password: "root",
      keyStr:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      pcount: "",
      verNuevo: 0,
      verDet: 0,
      overlay: false,
      borrarEval: false,
      mensajeBorrarSnack: false,
      mensajeCrearSnack: false,
    };
  },
  created() {
    this.init();
  },

  methods: {
    mostrarNuevo() {
      let me = this;
      this.verNuevo = 1;
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    getColorCondicion(condicion) {
      if (condicion == "Creado") {
        return "red";
      } else if (condicion == "Enviada") {
        return "orange";
      } else if (condicion == "Realizada") {
        return "green";
      } else if (condicion == false) {
        return "red";
      } else if (condicion == true) {
        return "green";
      } else {
        return "green";
      }
    },
    init() {
      let me = this;
      me.evaluaciones = [];
      me.overlay = true;
      var today = new Date();
      var fecha_inicio =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      fecha_inicio = moment().format("YYYY-MM-DD");

      db.collection("evaluaciones")
        .orderBy("fecha_Actual", "desc")
        .startAt(fecha_inicio)
        .endAt(fecha_inicio)
        .get()
        .then((snapshopChange) => {
          snapshopChange.forEach((doc) => {
            me.evaluaciones.push({
              key: doc.id,
              numeroAsistencia: doc.data().numeroAsistencia,
              condicion: doc.data().condicion,
              fecha: doc.data().fecha,
              compañia: doc.data().compañia,
              placa: doc.data().placa,
              pais: doc.data().pais,
              atencion_Telefonico: doc.data().atencion_Telefonico,
              atencion_Asesor: doc.data().atencion_Asesor,
              presentacion_Asesor: doc.data().presentacion_Asesor,
              explico_procedimiento: doc.data().explico_procedimiento,
              influenciado_Por_Asesor: doc.data().influenciado_Por_Asesor,
              influenciado_Por_Asesor_Porque: doc.data()
                .influenciado_Por_Asesor_Porque,
              proceso_Pago: doc.data().proceso_Pago,
              tiempo_Indemnizacion: doc.data().tiempo_Indemnizacion,
              evaluacion_aseguradora: doc.data().evaluacion_aseguradora,
              recomendaria_Compañia: doc.data().recomendaria_Compañia,
              recomendaria_Compañia_Porque: doc.data()
                .recomendaria_Compañia_Porque,
              poliza_Vehiculo_Aseguradora: doc.data()
                .poliza_Vehiculo_Aseguradora,
              poliza_Vehiculo_Aseguradora_Telefono: doc.data()
                .poliza_Vehiculo_Aseguradora_Telefono,
              poliza_Vehiculo_Aseguradora_Correo: doc.data()
                .poliza_Vehiculo_Aseguradora_Correo,
              influenciado_Por_pago: doc.data().influenciado_Por_pago,
              influenciado_Por_pago_Porque: doc.data()
                .influenciado_Por_pago_Porque,
              comentario_Adicional: doc.data().comentario_Adicional,
              fecha_Actual: doc.data().fecha_Actual,
              tipo_Encuesta: doc.data().tipo_Encuesta,
            });
          });
          me.overlay = false;
        })
        .catch((error) => {
          console.log(error);
          me.overlay = false;
        });
    },
    listar() {
      let me = this;
      if (me.itemInfome == "TODOS" && me.fechaInicio && me.fechaFin) {
        me.overlay = true;
        me.evaluaciones = [];
        db.collection("evaluaciones")
          .orderBy("fecha_Actual", "desc")
          .startAt(me.fechaInicio)
          .endAt(me.fechaFin)
          .get()
          .then((snapshopChange) => {
            snapshopChange.forEach((doc) => {
              if (doc.data().tipo_Encuesta == "ENCUESTA EVALUACION SERVICIO") {
                me.evaluaciones.push({
                  key: doc.id,
                  numeroAsistencia: doc.data().numeroAsistencia,
                  condicion: doc.data().condicion,
                  fecha: doc.data().fecha,
                  compañia: doc.data().compañia,
                  placa: doc.data().placa,
                  pais: doc.data().pais,
                  atencion_Telefonico: doc.data().atencion_Telefonico,
                  atencion_Asesor: doc.data().atencion_Asesor,
                  presentacion_Asesor: doc.data().presentacion_Asesor,
                  explico_procedimiento: doc.data().explico_procedimiento,
                  influenciado_Por_Asesor: doc.data().influenciado_Por_Asesor,
                  influenciado_Por_Asesor_Porque: doc.data()
                    .influenciado_Por_Asesor_Porque,
                  comentario_Adicional: doc.data().comentario_Adicional,
                  fecha_Actual: doc.data().fecha_Actual,
                  tipo_Encuesta: doc.data().tipo_Encuesta,
                });
              } else {
                me.evaluaciones.push({
                  key: doc.id,
                  numeroAsistencia: doc.data().numeroAsistencia,
                  condicion: doc.data().condicion,
                  fecha: doc.data().fecha,
                  compañia: doc.data().compañia,
                  placa: doc.data().placa,
                  pais: doc.data().pais,
                  proceso_Pago: doc.data().proceso_Pago,
                  tiempo_Indemnizacion: doc.data().tiempo_Indemnizacion,
                  evaluacion_aseguradora: doc.data().evaluacion_aseguradora,
                  recomendaria_Compañia: doc.data().recomendaria_Compañia,
                  recomendaria_Compañia_Porque: doc.data()
                    .recomendaria_Compañia_Porque,
                  poliza_Vehiculo_Aseguradora: doc.data()
                    .poliza_Vehiculo_Aseguradora,
                  poliza_Vehiculo_Aseguradora_Telefono: doc.data()
                    .poliza_Vehiculo_Aseguradora_Telefono,
                  poliza_Vehiculo_Aseguradora_Correo: doc.data()
                    .poliza_Vehiculo_Aseguradora_Correo,
                  influenciado_Por_pago: doc.data().influenciado_Por_pago,
                  influenciado_Por_pago_Porque: doc.data()
                    .influenciado_Por_pago_Porque,
                  comentario_Adicional: doc.data().comentario_Adicional,
                  fecha_Actual: doc.data().fecha_Actual,
                  tipo_Encuesta: doc.data().tipo_Encuesta,
                });
              }
            });
            me.overlay = false;
          })
          .catch((error) => {
            console.log(error);
            me.overlay = false;
          });
      } else if (
        me.itemInfome == "ENCUESTA EVALUACION SERVICIO" &&
        me.fechaInicio &&
        me.fechaFin
      ) {
        me.overlay = true;
        me.evaluaciones = [];
        db.collection("evaluaciones")
          .orderBy("fecha_Actual", "desc")
          .startAt(me.fechaInicio)
          .endAt(me.fechaFin)
          .get()
          .then((snapshopChange) => {
            snapshopChange.forEach((doc) => {
              if (doc.data().tipo_Encuesta == "ENCUESTA EVALUACION SERVICIO") {
                me.evaluaciones.push({
                  key: doc.id,
                  numeroAsistencia: doc.data().numeroAsistencia,
                  condicion: doc.data().condicion,
                  fecha: doc.data().fecha,
                  compañia: doc.data().compañia,
                  placa: doc.data().placa,
                  pais: doc.data().pais,
                  atencion_Telefonico: doc.data().atencion_Telefonico,
                  atencion_Asesor: doc.data().atencion_Asesor,
                  presentacion_Asesor: doc.data().presentacion_Asesor,
                  explico_procedimiento: doc.data().explico_procedimiento,
                  influenciado_Por_Asesor: doc.data().influenciado_Por_Asesor,
                  influenciado_Por_Asesor_Porque: doc.data()
                    .influenciado_Por_Asesor_Porque,
                  comentario_Adicional: doc.data().comentario_Adicional,
                  fecha_Actual: doc.data().fecha_Actual,
                  tipo_Encuesta: doc.data().tipo_Encuesta,
                });
              }
            });
            me.overlay = false;
          })
          .catch((error) => {
            console.log(error);
            me.overlay = false;
          });
      } else if (
        me.itemInfome == "ENCUESTA CIERRE SERVICIO" &&
        me.fechaInicio &&
        me.fechaFin
      ) {
        me.overlay = true;
        me.evaluaciones = [];
        db.collection("evaluaciones")
          .orderBy("fecha_Actual", "desc")
          .startAt(me.fechaInicio)
          .endAt(me.fechaFin)
          .get()
          .then((snapshopChange) => {
            snapshopChange.forEach((doc) => {
              if (doc.data().tipo_Encuesta == "ENCUESTA CIERRE SERVICIO") {
                me.evaluaciones.push({
                  key: doc.id,
                  numeroAsistencia: doc.data().numeroAsistencia,
                  condicion: doc.data().condicion,
                  fecha: doc.data().fecha,
                  compañia: doc.data().compañia,
                  placa: doc.data().placa,
                  pais: doc.data().pais,
                  proceso_Pago: doc.data().proceso_Pago,
                  tiempo_Indemnizacion: doc.data().tiempo_Indemnizacion,
                  evaluacion_aseguradora: doc.data().evaluacion_aseguradora,
                  recomendaria_Compañia: doc.data().recomendaria_Compañia,
                  recomendaria_Compañia_Porque: doc.data()
                    .recomendaria_Compañia_Porque,
                  poliza_Vehiculo_Aseguradora: doc.data()
                    .poliza_Vehiculo_Aseguradora,
                  poliza_Vehiculo_Aseguradora_Telefono: doc.data()
                    .poliza_Vehiculo_Aseguradora_Telefono,
                  poliza_Vehiculo_Aseguradora_Correo: doc.data()
                    .poliza_Vehiculo_Aseguradora_Correo,
                  influenciado_Por_pago: doc.data().influenciado_Por_pago,
                  influenciado_Por_pago_Porque: doc.data()
                    .influenciado_Por_pago_Porque,
                  comentario_Adicional: doc.data().comentario_Adicional,
                  fecha_Actual: doc.data().fecha_Actual,
                  tipo_Encuesta: doc.data().tipo_Encuesta,
                });
              }
            });
            me.overlay = false;
          })
          .catch((error) => {
            console.log(error);
            me.overlay = false;
          });
      } else {
        this.mensajeSnack = true;
      }
    },
    listarFiltros() {
      if (this.itemInfome == "TODOS" && this.fechaInicio && this.fechaFin) {
        for (let i = 0; i < this.evaluaciones.length; i++) {
          this.arrayTodo.push({
            numeroAsistencia: this.evaluaciones[i].numeroAsistencia,
            tipo_Encuesta: this.evaluaciones[i].tipo_Encuesta,
            fecha_Actual: this.evaluaciones[i].fecha_Actual,
            fecha: this.evaluaciones[i].fecha,
            compañia: this.evaluaciones[i].compañia,
            placa: this.evaluaciones[i].placa,
            pais: this.evaluaciones[i].pais,
            atencion_Telefonico: this.evaluaciones[i].atencion_Telefonico,
            atencion_Asesor: this.evaluaciones[i].atencion_Asesor,
            presentacion_Asesor: this.evaluaciones[i].presentacion_Asesor,
            explico_procedimiento: this.evaluaciones[i].explico_procedimiento,
            influenciado_Por_Asesor: this.evaluaciones[i]
              .influenciado_Por_Asesor,
            influenciado_Por_Asesor_Porque: this.evaluaciones[i]
              .influenciado_Por_Asesor_Porque,
            proceso_Pago: this.evaluaciones[i].proceso_Pago,
            tiempo_Indemnizacion: this.evaluaciones[i].tiempo_Indemnizacion,
            evaluacion_aseguradora: this.evaluaciones[i].evaluacion_aseguradora,
            recomendaria_Compañia: this.evaluaciones[i].recomendaria_Compañia,
            recomendaria_Compañia_Porque: this.evaluaciones[i]
              .recomendaria_Compañia_Porque,
            poliza_Vehiculo_Aseguradora: this.evaluaciones[i]
              .poliza_Vehiculo_Aseguradora,
            poliza_Vehiculo_Aseguradora_Telefono: this.evaluaciones[i]
              .poliza_Vehiculo_Aseguradora_Telefono,
            poliza_Vehiculo_Aseguradora_Correo: this.evaluaciones[i]
              .poliza_Vehiculo_Aseguradora_Correo,
            influenciado_Por_pago: this.evaluaciones[i].influenciado_Por_pago,
            influenciado_Por_pago_Porque: this.evaluaciones[i]
              .influenciado_Por_pago_Porque,
            comentario_Adicional: this.evaluaciones[i].comentario_Adicional,
            condicion: this.evaluaciones[i].condicion,
          });
        }
        this.ExportarExcel(this.arrayTodo);
      } else if (
        this.itemInfome == "ENCUESTA EVALUACION SERVICIO" &&
        this.fechaInicio &&
        this.fechaFin
      ) {
        for (let i = 0; i < this.evaluaciones.length; i++) {
          if (
            this.evaluaciones[i].tipo_Encuesta == "ENCUESTA EVALUACION SERVICIO"
          ) {
            this.arrayEvaluacion.push({
              numeroAsistencia: this.evaluaciones[i].numeroAsistencia,
              fecha_Actual: this.evaluaciones[i].fecha_Actual,
              fecha: this.evaluaciones[i].fecha,
              compañia: this.evaluaciones[i].compañia,
              placa: this.evaluaciones[i].placa,
              pais: this.evaluaciones[i].pais,
              atencion_Telefonico: this.evaluaciones[i].atencion_Telefonico,
              atencion_Asesor: this.evaluaciones[i].atencion_Asesor,
              presentacion_Asesor: this.evaluaciones[i].presentacion_Asesor,
              explico_procedimiento: this.evaluaciones[i].explico_procedimiento,
              influenciado_Por_Asesor: this.evaluaciones[i]
                .influenciado_Por_Asesor,
              influenciado_Por_Asesor_Porque: this.evaluaciones[i]
                .influenciado_Por_Asesor_Porque,
              comentario_Adicional: this.evaluaciones[i].comentario_Adicional,
              tipo_Encuesta: this.evaluaciones[i].tipo_Encuesta,
              condicion: this.evaluaciones[i].condicion,
            });
          }
        }

        this.ExportarExcel(this.arrayEvaluacion);
      } else if (
        this.itemInfome == "ENCUESTA EVALUACION SERVICIO" &&
        this.fechaInicio &&
        this.fechaFin
      ) {
        for (let i = 0; i < this.evaluaciones.length; i++) {
          if (
            this.evaluaciones[i].tipo_Encuesta == "ENCUESTA CIERRE SERVICIO"
          ) {
            this.arrayCierre.push({
              numeroAsistencia: this.evaluaciones[i].numeroAsistencia,
              fecha_Actual: this.evaluaciones[i].fecha_Actual,
              fecha: this.evaluaciones[i].fecha,
              compañia: this.evaluaciones[i].compañia,
              placa: this.evaluaciones[i].placa,
              pais: this.evaluaciones[i].pais,
              proceso_Pago: this.evaluaciones[i].proceso_Pago,
              tiempo_Indemnizacion: this.evaluaciones[i].tiempo_Indemnizacion,
              evaluacion_aseguradora: this.evaluaciones[i]
                .evaluacion_aseguradora,
              recomendaria_Compañia: this.evaluaciones[i].recomendaria_Compañia,
              recomendaria_Compañia_Porque: this.evaluaciones[i]
                .recomendaria_Compañia_Porque,
              poliza_Vehiculo_Aseguradora: this.evaluaciones[i]
                .poliza_Vehiculo_Aseguradora,
              poliza_Vehiculo_Aseguradora_Telefono: this.evaluaciones[i]
                .poliza_Vehiculo_Aseguradora_Telefono,
              poliza_Vehiculo_Aseguradora_Correo: this.evaluaciones[i]
                .poliza_Vehiculo_Aseguradora_Correo,
              influenciado_Por_pago: this.evaluaciones[i].influenciado_Por_pago,
              influenciado_Por_pago_Porque: this.evaluaciones[i]
                .influenciado_Por_pago_Porque,
              comentario_Adicional: this.evaluaciones[i].comentario_Adicional,
              tipo_Encuesta: this.evaluaciones[i].tipo_Encuesta,
              condicion: this.evaluaciones[i].condicion,
            });
          }
        }
        this.ExportarExcel(this.arrayCierre);
      } else {
        this.mensajeSnack = true;
      }
    },
    crearEncuesta() {
      let me = this;
      if (me.crear_Tipo_Encuesta == "ENCUESTA EVALUACION SERVICIO") {
        if (
          me.crear_Tipo_Encuesta != "" &&
          me.numeroAsistenciaRequest != "" &&
          me.fechaRequest != "" &&
          me.compañiaRequest != "" &&
          me.placaRequest != "" &&
          me.paisRequest != ""
        ) {
          db.collection("evaluaciones")
            .add({
              numeroAsistencia: me.numeroAsistencia,
              fecha: me.fechaRequest,
              compañia: me.compañiaRequest,
              placa: me.placaRequest,
              pais: me.paisRequest,
              atencion_Telefonico: me.atencion_Telefonico,
              atencion_Asesor: me.atencion_Asesor,
              presentacion_Asesor: me.presentacion_Asesor,
              explico_procedimiento: me.explico_procedimiento,
              influenciado_Por_Asesor: me.influenciado_Por_Asesor,
              influenciado_Por_Asesor_Porque: me.influenciado_Por_Asesor_Porque,
              comentario_Adicional: me.comentario_Adicional,
              fecha_Actual: new Date().toISOString().substr(0, 10),
              tipo_Encuesta: me.crear_Tipo_Encuesta,
              condicion: false,
            })
            .then(() => {
              me.init();
              me.limpiar();
              me.dialog = false;
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          me.mensajeCrearSnack = true;
        }
      } else {
        if (
          me.crear_Tipo_Encuesta != "" &&
          me.numeroAsistenciaRequest != "" &&
          me.fechaRequest != "" &&
          me.compañiaRequest != "" &&
          me.placaRequest != "" &&
          me.paisRequest != ""
        ) {
          db.collection("evaluaciones")
            .add({
              numeroAsistencia: me.numeroAsistencia,
              fecha: me.fechaRequest,
              compañia: me.compañiaRequest,
              placa: me.placaRequest,
              pais: me.paisRequest,
              proceso_Pago: me.proceso_Pago,
              tiempo_Indemnizacion: me.tiempo_Indemnizacion,
              evaluacion_aseguradora: me.evaluacion_aseguradora,
              recomendaria_Compañia: me.recomendaria_Compañia,
              recomendaria_Compañia_Porque: me.recomendaria_Compañia_Porque,
              poliza_Vehiculo_Aseguradora: me.poliza_Vehiculo_Aseguradora,
              poliza_Vehiculo_Aseguradora_Telefono:
                me.poliza_Vehiculo_Aseguradora_Telefono,
              poliza_Vehiculo_Aseguradora_Correo:
                me.poliza_Vehiculo_Aseguradora_Correo,
              influenciado_Por_pago: me.influenciado_Por_pago,
              influenciado_Por_pago_Porque: me.influenciado_Por_pago_Porque,
              comentario_Adicional: me.comentario_Adicional,
              fecha_Actual: new Date().toISOString().substr(0, 10),
              tipo_Encuesta: me.crear_Tipo_Encuesta,
              condicion: false,
            })
            .then(() => {
              me.dialog = false;
              me.init();
              me.limpiar();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          me.mensajeCrearSnack = true;
        }
      }
    },
    abrirDialogEliminarEval(item) {
      this.borrarEval = true;
      this.id = item.key;
    },
    eliminarEncuesta() {
      let me = this;
      db.collection("evaluaciones")
        .doc(me.id)
        .delete()
        .then(function() {
          me.init();
          me.borrarEval = false;
          me.mensajeBorrarSnack = true;
        })
        .catch(function(error) {
          console.log("Error removing document: ", error);
        });
    },
    verDetalles(item) {
      this.limpiar();
      this.id = item.key;
      this.idEvaluaciones = item.idEvaluaciones;
      this.numeroAsistencia = item.numeroAsistencia;
      this.condicion = item.condicion;
      this.fecha = item.fecha;
      this.compañia = item.compañia;
      this.placa = item.placa;
      this.pais = item.pais;
      this.atencion_Telefonico = item.atencion_Telefonico;
      this.atencion_Asesor = item.atencion_Asesor;
      this.presentacion_Asesor = item.presentacion_Asesor;
      this.explico_procedimiento = item.explico_procedimiento;
      this.influenciado_Por_Asesor = item.influenciado_Por_Asesor;
      this.influenciado_Por_Asesor_Porque = item.influenciado_Por_Asesor_Porque;
      this.comentario_Adicional = item.comentario_Adicional;
      this.proceso_Pago = item.proceso_Pago;
      this.tiempo_Indemnizacion = item.tiempo_Indemnizacion;
      this.evaluacion_aseguradora = item.evaluacion_aseguradora;
      this.recomendaria_Compañia = item.recomendaria_Compañia;
      this.recomendaria_Compañia_Porque = item.recomendaria_Compañia_Porque;
      this.poliza_Vehiculo_Aseguradora = item.poliza_Vehiculo_Aseguradora;
      this.poliza_Vehiculo_Aseguradora_Telefono =
        item.poliza_Vehiculo_Aseguradora_Telefono;
      this.poliza_Vehiculo_Aseguradora_Correo =
        item.poliza_Vehiculo_Aseguradora_Correo;
      this.influenciado_Por_pago = item.influenciado_Por_pago;
      this.influenciado_Por_pago_Porque = item.influenciado_Por_pago_Porque;
      this.tipo_Encuesta = item.tipo_Encuesta;
      this.fecha_Actual = item.fecha_Actual;
      this.verNuevo = 1;
      this.verDet = 1;
    },
    buscarNumeroAsistencia() {
      let me = this;
      me.errorPlaca = null;
      me.overlay = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Cabinas/MostrarCodigoNumAsistencia/" + this.numeroAsistencia,
          configuracion
        )
        .then(function(response) {
          me.detalles = response.data;
          me.agregarDetalle(response.data);
          me.overlay = false;
        })
        .catch(function(error) {
          console.log(error);
          me.errorPlaca = "No se encuentra registrado el numero de asistencia.";
          me.snackbarError = true;
          me.overlay = false;
          me.limpiar();
        });
    },
    agregarDetalle(data = []) {
      this.errorPlaca = null;
      this.numeroAsistenciaRequest = data["numeroAsistencia"];
      (this.fechaRequest = data["fechaHoraActual"]),
        (this.compañiaRequest = data["cartera"]),
        (this.placaRequest = data["placa"]),
        (this.paisRequest = data["pais"]);
    },
    limpiar() {
      this.idEvaluaciones = 0;
      this.numeroAsistencia = "";
      this.condicion = "";
      this.fecha = "";
      this.compañia = "";
      this.placa = "";
      this.pais = "";
      this.atencion_Telefonico = "";
      this.atencion_Asesor = "";
      this.presentacion_Asesor = "";
      this.explico_procedimiento = "";
      this.influenciado_Por_Asesor = "";
      this.influenciado_Por_Asesor_Porque = "";
      this.comentario_Adicional = "";
      this.proceso_Pago = "";
      this.tiempo_Indemnizacion = "";
      this.evaluacion_aseguradora = "";
      this.recomendaria_Compañia = "";
      this.recomendaria_Compañia_Porque = "";
      this.poliza_Vehiculo_Aseguradora = "";
      this.poliza_Vehiculo_Aseguradora_Telefono = "";
      this.poliza_Vehiculo_Aseguradora_Correo = "";
      this.influenciado_Por_pago = "";
      this.influenciado_Por_pago_Porque = "";
      this.tipo_Encuesta = "";
      this.crear_Tipo_Encuesta = "";
      this.fecha_Actual = "";
      this.fechaRequest = "";
      this.compañiaRequest = "";
      this.compañiaRequest = "";
      this.placaRequest = "";
      this.paisRequest = "";
      this.verDet = 0;
    },
    listarDetalles() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Cabinas/MostrarCodigoNumAsistencia/" + this.numeroAsistencia,
          configuracion
        )
        .then(function(response) {
          me.asignarCodigoArea(response.data);
          me.asignarTelefonoCliente(response.data);
          if (me.tipo_Encuesta == "ENCUESTA EVALUACION SERVICIO") {
            me.linkEncuestaEvaluacion();
          } else {
            me.linkEncuestaCierre();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    linkEncuestaEvaluacion() {
      this.sheetEncuestaEvaluacion = true;

      this.datosEncuestaEvaluacion =
        "Buen día, estimado cliente te invitamos de parte de Seguros Futuro, a completar nuestra encuesta, ingresa al link y responde según tu conveniencia: " +
        "\n" +
        "https://asistenciaregional.net/encuestaEvaluacion/" +
        this.id;
    },
    linkEncuestaCierre() {
      this.sheetEncuestaCierre = true;

      this.datosEncuestaCierre =
        "Link de la evaluacion: " +
        "\n" +
        "https://asistenciaregional.net/encuestaCierre/" +
        this.id;
    },
    //esta funcion estara pendiente hasta estar seguro de emplear condicion de enviado
    /*enviarEncuesta() {
      db.collection("evaluaciones")
        .doc(this.id)
        .update({"condicion": "Enviado"})
        .then(function() {
          console.log("Actualizado con exito!");
        })
        .catch(function(error) {
          console.log(error);
        });
    },*/
    asignarCodigoArea(data) {
      switch (data.pais) {
        case "EL SALVADOR":
          this.codigoSMS = "503";
          break;
        case "GUATEMALA":
          this.codigoSMS = "502";
          break;
        case "HONDURAS":
          this.codigoSMS = "504";
          break;
        case "NICARAGUA":
          this.codigoSMS = "503";
          break;
        case "COSTA RICA":
          this.codigoSMS = "505";
          break;
        case "PANAMÁ":
          this.codigoSMS = "507";
          break;
        case "BELICE":
          this.codigoSMS = "501";
          break;
        case "MÉXICO":
          this.codigoSMS = "52";
          break;
      }
    },
    asignarTelefonoCliente(data) {
      this.telefonoClienteEvaluacion = data.numeroTelefono;
      this.telefonoClienteCierre = data.numeroTelefono;
    },
    ExportarExcel(array = []) {
      let me = this;
      let data = XLSX.utils.json_to_sheet(array);
      const workbook = XLSX.utils.book_new();
      const filename = me.itemInfome;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
};
</script>
